import { render, staticRenderFns } from "./CampaignReportEstimateDetail.vue?vue&type=template&id=08c0b1ca&"
import script from "./CampaignReportEstimateDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignReportEstimateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports